module.exports = __webpack_public_path__ + "img/pixing_yj_maorunan.9c49e3b1.jpg";